// Libraries
import { rankItem } from '@tanstack/match-sorter-utils';
import { FilterFn } from '@tanstack/react-table';

/**
 * Applies a fuzzy filter to a row in a table.
 *
 * @param {unknown} row - The row to filter.
 * @param {string} columnId - The ID of the column to filter.
 * @param {string} value - The value to filter by.
 * @param {Function} addMeta - The function to add metadata to the filtered item.
 * @returns {boolean} - Indicates whether the item should be filtered in/out.
 */
export const fuzzyFilter: FilterFn<unknown> = (row, columnId, value, addMeta) => {
  // Rank the item
  const itemRank = rankItem(row.getValue(columnId), value);

  addMeta({
    itemRank,
  });

  // Return if the item should be filtered in/out
  return itemRank.passed;
};
